module.exports = __webpack_public_path__ + "static/media/doc.ffe15f59.png";